var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(0.2 -0.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_323",
    "data-name": "Ellipse 323",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(-0.2 0.4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8582",
    "data-name": "Path 8582",
    d: "M21.891,61H2.109A2.113,2.113,0,0,0,0,63.109V77.172a2.113,2.113,0,0,0,2.109,2.109H21.891A2.113,2.113,0,0,0,24,77.172V63.109A2.113,2.113,0,0,0,21.891,61ZM21.6,62.406l-9.555,9.555L2.407,62.406ZM1.406,76.881V63.394l6.772,6.714Zm.994.994L9.177,71.1l2.375,2.354a.7.7,0,0,0,.992,0l2.315-2.315,6.74,6.74Zm20.193-.994-6.74-6.74,6.74-6.74Z",
    transform: "translate(11.8 -45.74)",
    fill: "#feffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.baa919f2f7f5c5117b3a5c3ff7eea04a.svg";
export { ForwardRef as ReactComponent };